import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import GenericTable from "../common/GenericTable"; // Assuming you have a reusable table component
import { useSelector } from "react-redux";
import { CheckCircle } from "@mui/icons-material"; // Import the icon
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { checkout, clearCart } from "../../redux/cartSlice";
import { Link } from "@mui/material";



const Thankyou = () => {
//   const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'asc' });
//   const { items, loading, error, checkoutStatus } = useSelector(
//     (state) => state.cart
//   );
//   const dispatch = useDispatch();
//   const cartItems = location.state?.cartItems || [];

//   useEffect(() => {
//     if (items) {
//       setCartItems(items?.data?.cart_items || []);
//     }
//   }, [items]);



//   // Columns for displaying cart items in a table
//   const columns = [
//     { label: "Product", key: "product_name" },
//     { label: "Quantity", key: "quantity" },
//     { label: "Price", key: "price" },
//     { label: "Total", key: "total" },
//   ];

//   const handleSort = (columnKey) => {
//     const direction =
//       sortConfig.key === columnKey && sortConfig.direction === "asc"
//         ? "desc"
//         : "asc";
//     setSortConfig({ key: columnKey, direction });
//     const sortedData = [...cartItems].sort((a, b) => {
//       if (a[columnKey] < b[columnKey]) return direction === "asc" ? -1 : 1;
//       if (a[columnKey] > b[columnKey]) return direction === "asc" ? 1 : -1;
//       return 0;
//     });
//     setCartItems(sortedData);
//   };


//   console.log("Cart Items: ", cartItems);


  return (
    <Box sx={{
        display: 'flex',         
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',  
        height: '70vh',         
        textAlign: 'center',  
        padding: 4,            
      }}>
      <Typography variant="h4" gutterBottom sx={{color: "#C31E40", textAlign:"center"}}>
        Thank you for your order!
      </Typography>
      <Box
        sx={{
            display: "flex",
            justifyContent: "center", // Centers horizontally
            alignItems: "center",
            marginBottom: "16px" // Centers vertically
        }}
        >
        <CheckCircle sx={{ color: "#C31E40", fontSize: "64px" }} />
      </Box>
      <Typography variant="body1" gutterBottom sx={{color: "#333333", textAlign:"center"}}>
        Your order has been received and will be processed shortly. You can view your order history&nbsp;
        <Link href="/my/order-history" sx={{ textDecoration: 'underline', color: '#333333' }}>
          here
        </Link>.
      </Typography>
      
    </Box>
  );
};

export default Thankyou;
